



























































import { Vue, Component } from 'vue-property-decorator';
import { getList } from '../api';
import { List, Picker, Popup } from 'vant';
import VoteButtonNew from '../components/VoteButtonNew.vue';
Vue.use(List)
  .use(Picker)
  .use(Popup);
@Component({
  components: {
    VoteButtonNew,
  },
})
export default class Home extends Vue {
  showPicker: boolean = false;
  voteName: string = '2022project/q4/2022police';
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  keyWord = '全部';
  columns: any = [
    '全部',
    '渝中',
    '大渡口',
    '江北',
    '沙坪坝',
    '南岸',
    '北碚',
    '巴南',
    '高新',
    '长寿',
    '合川',
    '南川',
    '潼南',
    '铜梁',
    '荣昌',
    '璧山',
    '梁平',
    '垫江',
    '开州',
    '巫山',
    '巫溪',
    '黔江',
    '武隆',
    '彭水',
    '高速二支队',
    '交巡警总队',
    '高速一支队',
    '高速三支队',
    '高速四支队',
    '高速五支队',
    '江津',
    '渝北',
    '九龙坡',
    '涪陵',
    '两江新区交巡警',
    '万州交巡警',
  ];
  onLoad() {
    this.keyWord = (localStorage.getItem('0103XJPX') as string)
      ? (localStorage.getItem('0103XJPX') as string)
      : this.keyWord;
    getList(this.page, this.keyWord === '全部' ? '' : this.keyWord).then(
      (res: any) => {
        this.endListData(res);
      },
    );
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode === 404) {
      this.finished = true;
    } else {
      if (!res.data || res.data.length === 0) {
        this.finished = true;
      } else {
        if (!res.data || res.data.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data];
        }
      }
    }
    this.loading = false;
  }
  votSuccess(data: any, index: number) {
    this.list[index].votes = data;
  }
  onConfirm(value: any, index: any) {
    localStorage.setItem('0103XJPX', value);
    this.list = [];
    this.page = 1;
    this.loading = true;
    this.finished = false;
    this.keyWord = value;
    this.showPicker = false;
    this.onLoad();
  }
  onCancel() {
    this.showPicker = false;
  }
  goOut(url: string) {
    localStorage.setItem('0103XJPX', this.keyWord);
    window.location.href = url;
  }
}
